class fostrCardMediaSwipe extends HTMLElement {
  constructor() {
    super();
    this.cardMedia = this.querySelector('.card__media .media');
    this.hasSecondImage = this.dataset.secondImage;
    this.reverseImageOrder = false;
    if (this.hasSecondImage) {
      this.initialiseSwipe();
    }

    this.addPLPPageNumberAttribute();
    this.handlePLPProductCardClick();
  }

  addPLPPageNumberAttribute() {
    if (this.getAttribute('data-page')) {
      return;
    }

    const ul = this.closest('ul');
    if (!ul) {
      return;
    }

    const page = ul.querySelector('[data-page]');
    if (!page) {
      return;
    }

    this.setAttribute('data-page', page.getAttribute('data-page'))
  }

  handlePLPProductCardClick() {
    if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) {
      return;
    }

    const pageNumber = this.getAttribute('data-page');
    const linkEls = this.querySelectorAll('a');

    if (!linkEls) return;

    for (let i = 0; i < linkEls.length; i++) {
      const linkEl = linkEls[i];
      this.handlePLPProductCardLinkClick(linkEl, pageNumber);
    }
  }

  handlePLPProductCardLinkClick(linkEl, pageNumber) {
    linkEl.addEventListener('click', (e) => {
      e.preventDefault();

      let newUrl = window.location.href.split('?');
      if (pageNumber) {
        if (newUrl[1]) {
          newUrl[1] = newUrl[1].replace(/page=[^&]+&?/, '');
          newUrl = newUrl[0] + '?' + newUrl[1] + '&page=' + pageNumber;
        } else {
          newUrl = newUrl[0] + '?page=' + pageNumber;
        }
      } else {
        newUrl = newUrl[0];
      }

      newUrl = newUrl.replace('?&', '?').replace('&&', '&');

      const productId = this.dataset.productId;
      if (productId) {
        if (window.location.href.includes('#')) {
          // yes, remove the hash
          newUrl = newUrl.split('#')[0];
          // add product id hash
          newUrl = newUrl + '#pid=' + productId;

        } else {
          // if no, then add the hash value
          newUrl = newUrl + '#pid=' + productId;
        }
      }

      // push new url reset scroll position
      window.history.pushState({ scrollTop: 0 }, '', newUrl);

      // undo e.preventDefault() and follow the link
      window.location.href = linkEl.href;
    })
  }

  swipeCardImage(direction) {
    let swipeSecondImage = this.cardMedia.dataset.swipeSecondImage != 'true';
    if (this.reverseImageOrder == true) {
      swipeSecondImage = !swipeSecondImage;
      this.reverseImageOrder = false;
    }
    this.cardMedia.setAttribute('data-swipe-second-image', swipeSecondImage);
    this.cardMedia.setAttribute('data-swipe-direction', direction);
  }

  resetImages() {
    this.resetButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.cardMedia.removeAttribute('data-swipe-second-image');
        this.cardMedia.removeAttribute('data-swipe-direction');
        this.reverseImageOrder = !this.reverseImageOrder;
      });
    });
  }

  initialiseSwipe() {
    let touchstartX = 0;

    const checkDirection = (touchendX) => {
      if (touchendX < touchstartX - 30) {
        this.swipeCardImage('left');
      } else if (touchendX > touchstartX + 30) {
        this.swipeCardImage('right');
      }
    }

    this.addEventListener('touchstart', event => {
      touchstartX = event.changedTouches[0].screenX;
    })

    this.addEventListener('touchend', event => {
      checkDirection(event.changedTouches[0].screenX);
    })

    this.resetButtons = document.querySelectorAll('.model-view-button');
    if (this.resetButtons.length > 0) {
      this.resetImages();
    }
  }
}

window.customElements.define('fostr-card-media-swipe', fostrCardMediaSwipe);